// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_NOTIFICATION_ALERT = 'notification-alert/SET_VIEW_TYPE';
